// extracted by mini-css-extract-plugin
export default {"card":"Card_card__i7gv0","link":"Card_link__HO2gY","img":"Card_img__B6dGL","name":"Card_name__07qHp","subtitle":"Card_subtitle__H4Gtp","price":"Card_price__+xq8j"};